import React from 'react'

import { Avatar } from './style'

export const DropdownAvatar = ({ avatarUrl, className }) => (
  <Avatar
    id={'dropdown-avatar'}
    title={''}
    src={avatarUrl}
    responsive
    rounded
  />
)



// WEBPACK FOOTER //
// ./src/Components/Header/DropdownAvatar/index.js